import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconText = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 25"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M1.5 4.598V3.88c0-.573.236-1.123.658-1.529a2.298 2.298 0 011.592-.633h16.5c.597 0 1.17.228 1.592.633.422.406.659.956.658 1.53v.72M12 1.718v21.6M7.5 23.318h9",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconText.displayName = "IconText";

export { IconText };
